import { BasicApplicationRouter } from '../../../../../shared/services/BasicApplicationRouter';

export class AppRouterService extends BasicApplicationRouter<MyVehicleAppDefinition> {
	private readonly successUrl: string;
	constructor(options: BasicAppOptions<MyVehicleAppDefinition>) {
		super(options);
		this.successUrl = options.app.successurl;
		if (!this.successUrl) {
			const backlinks = $('.js-csspage-backlink');
			if (backlinks.length) {
				this.successUrl = (backlinks[0] as HTMLAnchorElement).href;
			}
		}
	}

	public success(): void {
		this.routeToLocation(this.successUrl);
	}
}